module.exports = __webpack_public_path__ + "img/menu2.ee37b676.jpg";